export function formatStringToNumber(value: string) {
  if (value.indexOf(',') > -1) {
    value = value.replace(',', '.')
  }
  return Number(value)
}
